import React from "react"
import { Link } from "gatsby"
import Logo from "../images/logo_170x170.png"
import { Navbar, Nav } from "react-bootstrap"

const Navigation = () => {
  return (
    <div className="container">
      <Navbar expand="xl">
        <Navbar.Brand>
          <Link to="/">
            <img src={Logo} alt="Logo de Catherine Couten" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav className="ml-auto" activeKey="">
            <Nav.Item>
              <Link to="/" activeClassName="active">
                Accueil
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link
                to="/sophrologie/"
                partiallyActive={true}
                activeClassName="active"
              >
                La sophrologie
              </Link>
              <SubMenu>
                <Link to="/sophrologie/qu-est-ce-que-c-est">
                  Qu'est-ce que c'est ?
                </Link>
                <Link to="/sophrologie/pratique-sophrologie">
                  Comment elle se pratique ?
                </Link>
                <Link to="/sophrologie/deroulement-seance">
                  Déroulement d'une séance
                </Link>
                <Link to="/sophrologie/pour-qui">Pour qui ?</Link>
                <Link to="/sophrologie/pourquoi-consulter">
                  Pourquoi consulter ?
                </Link>
                <Link to="/sophrologie/avantages">Les avantages</Link>
                <Link to="/sophrologie/role-sophrologue">
                  Le rôle d'une sophrologue
                </Link>
                <Link to="/sophrologie/deontologie">Déontologie</Link>
              </SubMenu>
            </Nav.Item>
            <Nav.Item>
              <Link to="/votre-sophrologue/" activeClassName="active">
                Votre sophrologue
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="#" partiallyActive={true} activeClassName="active">
                Prestations
              </Link>
              <SubMenu>
                <Link to="/coherence-cardiaque/" activeClassName="active">
                  Cohérence cardiaque
                </Link>
                <Link to="/hypnose/" activeClassName="active">
                  Hypnose
                </Link>
                <Link to="/ateliers-collectifs/" activeClassName="active">
                  Ateliers collectifs
                </Link>
              </SubMenu>
            </Nav.Item>
            <Nav.Item>
              <Link to="/entreprises/" activeClassName="active">
                Entreprises
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/enfants/" activeClassName="active">
                Enfants
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/contact/" activeClassName="active">
                Contact
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/blog/" partiallyActive={true} activeClassName="active">
                Blog
              </Link>
            </Nav.Item>
            <Nav.Item>
              <a
                href="https://www.crenolib.fr/therapeute/sophrologue-et-hypnotherapeute/senlis/60300/5487-catherine_couten"
                target="_blank"
                rel="noreferrer"
              >
                Prendre rendez-vous
              </a>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  )
}

const SubMenu = ({ children }) => {
  return <div className="submenu">{children}</div>
}

export default Navigation
